import apiClient from "../apiClient";

export default {
    getAll: params => apiClient.get(`holidays?${params}`),
    get: id => apiClient.get(`holidays/${id}`),
    add: payload => apiClient.post("holidays", payload),
    edit: (id, payload) => apiClient.put(`holidays/${id}`, payload),
    delete: id => apiClient.delete(`holidays/${id}`),
    apply: id => apiClient.post(`holidays/${id}/apply`),
    reverse: id => apiClient.post(`holidays/${id}/reverse`),
    deductions: id => apiClient.get(`holidays/${id}/deductions`),
    bridgeSuggestions: year => apiClient.get(`holidays/bridge-suggestions?year=${year}`),

    // Attendance: absence days -> approved leave
    convertAbsences: payload => apiClient.post("attendance/absences/convert", payload),
};
